
const routes = [

  // {
  //   path: '/kk',
  //   name: 'kk-login',
  //   component: () => import(/* webpackChunkName: "kk-login" */ '@/views/kk/Login.vue')
  // },
  {
    path: '/kk',
    meta: { requiresAuth: true },
    component: () => import(/* webpackChunkName: "kk-layout" */ '@/views/kk/_Layout.vue'),
    children: [
      {
        path: 'forside',
        name: 'kk-home',
        component: () => import(/* webpackChunkName: "kk-home" */ '@/views/kk/Home.vue')
      }
    ]
  },

]

export default routes